import { render, staticRenderFns } from "./ag-menu-header.vue?vue&type=template&id=e0a6bca2&scoped=true"
import script from "./ag-menu-header.vue?vue&type=script&lang=js"
export * from "./ag-menu-header.vue?vue&type=script&lang=js"
import style0 from "./ag-menu-header.vue?vue&type=style&index=0&id=e0a6bca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a6bca2",
  null
  
)

export default component.exports